import { red, lightBlue, grey, amber, green } from '@mui/material/colors';

function roundToDigits(number, digits) {
  return Number.parseFloat(number).toFixed(digits);
}
// Celicius is spelled wrong in the HTR data exporter function - fix it or change to 'C'
function convertTemp(desired_unit = 'F', unit, value) {
  if (unit === desired_unit) {
    return value;
  } else if (unit === 'Celcius' && desired_unit === 'F') {
    const F = value * (9 / 5) + 32;
    return Number(F);
  } else if (unit === 'Fahrenheit' && desired_unit === 'C') {
    const C = (value - 32) * (5 / 9);
    return Number(C);
  } else {
    console.log('problem converting temperature');
  }
}

export function waterTempProcessing(raw_metric, desired_unit) {
  const [time, metName, val, unit, min, max] = raw_metric;
  const temp = convertTemp(desired_unit, unit, val);
  let colorThingObj = {};
  if (temp > 0 && temp <= 160) {
    colorThingObj = {
      backgroundColor: lightBlue[100],
      borderColor: lightBlue[400],
    };
  } else if (temp > 160 && temp <= 190) {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: green['A400'],
    };
  } else if (temp > 190 && temp <= 210) {
    colorThingObj = {
      backgroundColor: amber[300],
      borderColor: amber[600],
    };
  } else if (temp > 210) {
    colorThingObj = {
      backgroundColor: red[300],
      borderColor: red[600],
    };
  } else {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: grey[600],
    };
  }
  return [colorThingObj, roundToDigits(temp, 0)];
}

// make stuff lowercase so it matches better
function convertSpeed(desired_unit = 'MPH', unit, value) {
  if (unit === desired_unit) {
    return value;
  } else if (unit === 'mph' && desired_unit === 'kph') {
    const kph = value * 1.60934;
    return Number(kph);
  } else if (unit === 'kph' && desired_unit === 'mph') {
    const mph = value * 0.621371;
    return Number(mph);
  } else {
    console.log('problem converting speed');
  }
}

export function speedProcessing(raw_metric, desired_unit) {
  const [time, metName, val, unit, min, max] = raw_metric;
  const speed = convertSpeed(desired_unit, unit, val);
  const mphSpeed = convertSpeed('mph', unit, val); // colors always use MPH
  let colorThingObj = {};
  if (mphSpeed <= 5) {
    colorThingObj = {
      backgroundColor: red[300],
      borderColor: red[600],
    };
  } else if (mphSpeed > 5) {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: green['A400'],
    };
  } else {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: grey[600],
    };
  }
  return [colorThingObj, roundToDigits(speed, 0)];
}

// make stuff lowercase so it matches better
function convertPressure(desired_unit = 'PSI', unit, value) {
  if (unit === desired_unit) {
    return value;
  } else if (unit === 'psi' && desired_unit === 'bar') {
    const bar = value / 14.504;
    return Number(bar);
  } else if (unit === 'bar' && desired_unit === 'psi') {
    const psi = value * 14.504;
    return Number(psi);
  } else {
    console.log('problem converting pressure');
  }
}

export function oilPressureProcessing(raw_metric, desired_unit) {
  const [time, metName, val, unit, min, max] = raw_metric;
  const pressure = convertPressure(desired_unit, unit, val);
  const psiPressure = convertPressure('psi', unit, val); // colors always use PSI
  let colorThingObj = {};
  if (psiPressure <= 40) {
    colorThingObj = {
      backgroundColor: red[300],
      borderColor: red[600],
    };
  } else if (psiPressure > 40) {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: green['A400'],
    };
  } else {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: grey[600],
    };
  }
  return [colorThingObj, roundToDigits(pressure, 1)];
}

export function batteryProcessing(raw_metric) {
  const [time, metName, val, unit, min, max] = raw_metric;
  const volts = val;
  let colorThingObj = {};
  if (volts <= 12) {
    colorThingObj = {
      backgroundColor: red[300],
      borderColor: red[600],
    };
  } else if (volts > 12 && volts <= 14) {
    colorThingObj = {
      backgroundColor: grey[300],
      // backgroundColor: amber[300],
      borderColor: amber[600],
    };
  } else if (volts > 14) {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: green['A400'],
    };
  } else {
    colorThingObj = {
      backgroundColor: grey[300],
      borderColor: grey[600],
    };
  }
  return [colorThingObj, roundToDigits(volts, 1)];
}
